<template>
  <v-card class="pa-0" elevation="0">
    <v-card-text class="px-6 py-6">
      <div v-if="loading !== ''" class="py-16 text-center">
        <br><br><br>
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <p class="mx-auto mt-10" style="max-width: 300px">
          {{ loading }}
        </p>
        <br><br><br>
      </div>

      <template v-else>
        <div class="py-16 text-center">
          <v-icon color="primary" size="60">mdi-credit-card</v-icon>
          <p class="mx-auto mt-10" style="max-width: 300px">
            Setup auto-debit on your account, click the button below to continue
          </p>
          <v-btn class="mt-5" color="primary" elevation="0" @click="start()">Continue</v-btn>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
	export default {
		name: "RepaymentWidget",
		data() {
			return {
				loading: '',
				request: this.$store.state.request,
				merchant: this.$store.state.merchant,
				iframe: null
			}
		},
		mounted() {
			window.addEventListener("message", this.handleMessage);
		},
		beforeDestroy() {
			window.removeEventListener("message", this.handleMessage);
			if (this.iframe) this.iframe.remove();
		},
		methods: {
			handleMessage(e) {
				if (!e.data || !e.data.id) return;
				if (e.data.id === 'success') {
					this.addToCompleted();
					this.iframe.remove();
					this.$emit('done');
				}
				if (e.data.id === 'cancel') {
					this.iframe.remove();
				}
			},
			start() {
				this.launchRepaymentWidget()
			},
			async launchRepaymentWidget() {
				let request_id = this.request.creditclan_request_id;
				if (!request_id) request_id = await this.createCCRequest();
				if (!request_id) return console.log('No request id');
				this.loading = 'Please wait..';
				const res = await this.$http.post('https://mobile.creditclan.com/api/v3/card/tokenization', {
					request_id,
				}, { headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' } });
				this.loading = '';
				if (res.status && res.data.url) return this.launchIframe('repayment', res.data.url);
			},
			launchIframe(id, url) {
				const iframe = document.createElement("IFRAME");
				iframe.setAttribute("src", url);
				iframe.setAttribute("allow", "geolocation");
				const style = {
					'z-index': '999999',
					display: 'block',
					background: 'rgba(0, 0, 0, 0.004)',
					border: '0px none transparent',
					overflow: 'hidden',
					visibility: 'visible',
					margin: '0px',
					padding: '0px',
					position: 'fixed',
					left: '0px',
					top: '0px',
					width: '100%',
					height: '100%',
				};
				Object.assign(iframe.style, style);
				iframe.marginwidth = "0";
				iframe.marginheight = "0";
				iframe.frameBorder = "0";
				iframe.vspace = "0";
				iframe.id = id;
				this.iframe = iframe;
				document.body.append(iframe);
			},
			async addToCompleted() {
				this.loading = 'Saving..';
				const analysis_completed = [...this.request.analysis_completed];
				analysis_completed.push('repayment');
				await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages/${ this.request.id }`, {
					analysis_completed, type: 'customer'
				});
				this.$store.commit('request/set', { analysis_completed });
				this.loading = '';
			},
			async checkUser() {
				const { email, phone } = this.$store.state.customer.personal;
				try {
					const { data } = await this.$http.post(`https://mobile.creditclan.com/api/v3/customer/check/details`, { email, phone }, {
						headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
					});
					const { token, user_id } = data;
					return { token, user_id };
				} catch (e) {
					// this.setError('An error occurred, please try again!');
					return {};
				}
			},
			async createCCRequest() {
				const { customer, request, merchant } = this.$store.state;
				const { user_id } = await this.checkUser();
				const payload = {
					request: {
						amount: request.total_credit,
						tenor: request.no_of_months,
					},
					profile: {
						full_name: customer.personal.full_name,
						email: customer.personal.email,
						phone: customer.personal.phone,
						date_of_birth: customer.personal.date_of_birth,
						profile_image: '',
						user_id
					},
					home_address: {
						address: customer.personal.address,
						state_id: customer.personal.state,
						lga_id: customer.personal.lga
					},
					merchant_id: merchant.id,
				};
				const res = await this.$http.post('https://mobile.creditclan.com/api/v3/loan/apply', payload, {
					headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
				});
				if (!res.data.status) return null;
				this.saveCreditclanRequestId(res.data.dd);
				this.$store.commit('request/set', { request_id: res.data.dd });
				return res.data.dd;
			},
			async saveCreditclanRequestId(creditclan_request_id) {
				const request_id = this.$store.state.request.id;
				await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/request/${ request_id }`, { creditclan_request_id })
				this.$store.commit('request/set', { creditclan_request_id });
			}
		},
	}
</script>
